import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDebounce } from 'use-lodash-debounce'
import AuthService from '~/api/services/auth'
import { FormFields } from '~/components/FormFields'
import { useParams } from 'react-router-dom'
import { useWatch } from 'react-hook-form'
import { handleErrors } from '~/utils/helpers'
import { El } from './style'
import { Dimmer, Icon, Loader } from 'semantic-ui-react'
import styled from 'styled-components'

interface Props {
  keyName?: string
  control: any
  verificationLabel: string
  onChangeCorrectTwoFaCode: (correctTwoFaCode: boolean) => void
  reset?: boolean
}

const StyledDimmer = styled(Dimmer)`
margin-left: 10px;
font-size: 1.6em;
margin-top: 5px;
display: flex !important;
background: none !important;
 .ui.small.active.loader {
  &:before: {
    border-color: green !important;
  }
 }
`

const Wrapper = styled.div`
display: flex;
align-items: center;
  label {
    white-space: nowrap !important;
    margin-bottom: 0px;
    margin-left: -135px !important;
  }
`

const TwoFaField: React.FC<Props> = (props) => {
  const {
    keyName,
    control,
    verificationLabel,
    onChangeCorrectTwoFaCode,
    reset
  } = props
  const { t } = useTranslation()
  const { code } = useParams();

  const [correctTfaCode, setCorrectTfaCode] = useState(false)
  const [loadingTfaCode, setLoadingTfaCode] = useState(false)

  const watchTwoFaField = useWatch({ control, name: keyName })
  const codeValue = useDebounce(watchTwoFaField, 300);

  useEffect(() => {
    if (codeValue && codeValue !== '') {
      checkCode()
    } else if (codeValue === '') {
      setCorrectTfaCode(false)
    }
  }, [codeValue])

  async function checkCode() {
    setLoadingTfaCode(true)
    try {
      let response
      if (reset) {
        response = await AuthService.checkResetTwoFaCode({ code, pinCode: watchTwoFaField })
      } else {
        response = await AuthService.checkTwoFaCode({ code, pinCode: watchTwoFaField })
      }
      setCorrectTfaCode(response.data === 1)
      onChangeCorrectTwoFaCode(response.data === 1)
    } catch (error) {
      handleErrors(error)
    }
    setLoadingTfaCode(false)
  }

  function renderTfaCodeAuth() {
    return <Wrapper>
      <FormFields.Input
        style={El.loginFormField}
        label={t('Two-Factor Authentication ({{verificationLabel}})', { verificationLabel })}
        name={keyName}
        icon='briefcase'
        iconPosition='left'
        control={control}
        placeholder={t('Enter code here')}
        rules={{
          required: {
            value: true,
            message: t('Please enter 2FA code')
          }
        }}
      />
      <div style={{ position: 'relative', margin: 'auto', marginLeft: 10, marginTop: 23, marginRight: 5 }}>
        {loadingTfaCode && <StyledDimmer inverted active={loadingTfaCode}>
          <Loader size='small' active={loadingTfaCode} />
        </StyledDimmer>}
      </div>
      {!loadingTfaCode && <Icon
        style={{
          marginLeft: 10,
          marginBottom: 10,
          fontSize: '1.6em'
        }}
        name={correctTfaCode ? 'checkmark' : 'close'}
        color={correctTfaCode ? 'green' : 'red'}
      />}
    </Wrapper>
  }

  return <>
    {renderTfaCodeAuth()}
  </>
}
export default TwoFaField